/** The route fields this reader uses. `ui` cannot import `next/router`. */
type RouteWithSessionId = { query: { id?: string | string[] } };

/**
 * Reads the current session id from the Next.js router query, handling both
 * the legacy `[id]` (string) and new `[[...id]]` (string[]) route shapes.
 * Returns `''` when no session id is present.
 */
export function getCurrentRouteSessionId(router: RouteWithSessionId): string {
  const routeId = router.query.id;
  if (Array.isArray(routeId)) return routeId[0] ?? '';
  return routeId ?? '';
}
